module.exports = __webpack_public_path__ + "images/opel2a910735d40e93f98ca07b554636c9fb.png";